import { useLocation } from 'react-router-dom'
import UtmLink from './UtmLink'

const Logo = ({ variant = 'default' }) => {
  const location = useLocation()

  const handleLogoClick = e => {
    if (location.pathname === '/') {
      e.preventDefault()
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    }
  }

  return (
    <UtmLink
      to="/"
      className="flex items-center space-x-2"
      onClick={handleLogoClick}
    >
      <div
        className={variant === 'footer' ? 'rounded-md bg-white px-3 py-2' : ''}
      >
        <img
          src="/Logo/ycm-logo.svg"
          alt="Your Claim Matters"
          style={variant === 'footer' ? { height: '75px' } : undefined}
          className={
            variant === 'footer'
              ? 'w-auto transition-opacity hover:opacity-80'
              : 'h-12 w-auto scale-125 transition-opacity hover:opacity-80 md:h-14'
          }
        />
      </div>
    </UtmLink>
  )
}

export default Logo
